import { cva } from '@/styled-system/css';

export const comboboxTriggerRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: { base: 'Combobox.Trigger.bg.default' },
    boxShadow: 'inset 0 0 0 {borderWidths.Combobox.Trigger} var(--shadow-color)',
    boxShadowColor: { base: 'Combobox.Trigger.border.default' },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        'cursor': 'text',
        'backgroundColor': {
          _hover: 'Combobox.Trigger.bg.hover',
          _active: 'Combobox.Trigger.bg.active',
        },
        'boxShadowColor': {
          _hover: 'Combobox.Trigger.border.hover',
          _active: 'Combobox.Trigger.border.active',
        },

        '&:has(input:focus)': {
          backgroundColor: { base: 'Combobox.Trigger.bg.active' },
          boxShadow:
            'inset 0 0 0 {borderWidths.Combobox.Trigger} var(--shadow-color), {shadows.focus}',
          boxShadowColor: { base: 'Combobox.Trigger.border.active' },
        },
      },
    },
    error: {
      true: {
        backgroundColor: { base: 'Combobox.Trigger.bg.error' },
        boxShadowColor: { base: 'Combobox.Trigger.border.error' },
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'Combobox.Trigger.sm',
        paddingBlock: 'Combobox.Trigger.sm.padding.vert',
        paddingInline: 'Combobox.Trigger.sm.padding.horz',
      },
      md: {
        borderRadius: 'Combobox.Trigger.md',
        paddingBlock: 'Combobox.Trigger.md.padding.vert',
        paddingInline: 'Combobox.Trigger.md.padding.horz',
      },
      lg: {
        borderRadius: 'Combobox.Trigger.lg',
        paddingBlock: 'Combobox.Trigger.lg.padding.vert',
        paddingInline: 'Combobox.Trigger.lg.padding.horz',
      },
    },
  },
  compoundVariants: [
    {
      disabled: false,
      error: true,
      css: {
        'backgroundColor': {
          _hover: 'Combobox.Trigger.bg.errorHover',
          _active: 'Combobox.Trigger.bg.errorActive',
        },
        'boxShadowColor': {
          _active: 'Combobox.Trigger.border.errorActive',
          _hover: 'Combobox.Trigger.border.errorHover',
        },
        '&:is(:hover:active)': {
          backgroundColor: { base: 'Combobox.Trigger.bg.errorHover' },
        },
        '&:has(input:focus)': {
          backgroundColor: { base: 'Combobox.Trigger.bg.errorActive' },
          boxShadowColor: { base: 'Combobox.Trigger.border.errorActive' },
        },
      },
    },
  ],
});
